module.exports = __webpack_public_path__ + "img/features.5ded1fee.webp";